import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=12c9050b&scoped=true&"
import script from "./Assessment.vue?vue&type=script&lang=js&"
export * from "./Assessment.vue?vue&type=script&lang=js&"
import style0 from "./Assessment.vue?vue&type=style&index=0&id=12c9050b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9050b",
  null
  
)

export default component.exports